import React from "react";
import PropTypes from "prop-types";
import ContainerWrapperIntern from "../ContainerWrapperIntern";
import PJContainer from "./PJContainer";

const PJContainerWrapper = props => {
  return <ContainerWrapperIntern {...props} Container={PJContainer}></ContainerWrapperIntern>;
};
PJContainerWrapper.propTypes = {
  value: PropTypes.any,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  onTextFieldChange: PropTypes.func.isRequired,
  helperText: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  required: PropTypes.bool,
  iconHidden: PropTypes.bool,
  error: PropTypes.bool,
  hasCustomIcons: PropTypes.bool,
  iconDisabled: PropTypes.bool,
  customEndIcons: PropTypes.node,
  partnerTypeId: PropTypes.number
};

export default PJContainerWrapper;
